Vue.filter('wishListItemVariationProperties', function (variationId) {
  if (WishListItems && WishListItems.hasOwnProperty(variationId)) {
    return WishListItems[variationId];
  }

  return false;
});
